'use client';

export default function Atelier() {
  return (
    <section
      id="atelier"
      className="relative py-24 sm:py-32 overflow-hidden bg-[#0a0a0f]"
    >
      {/* Decorative top gold hairline */}
      <div className="gold-divider max-w-3xl mx-auto mb-20" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Left — portrait image */}
        <div className="relative">
          <div className="relative aspect-[3/4] overflow-hidden border-gold-thin glow-gold">
            <img
              src="/images/matar-portrait.png"
              alt="Portrait de S.E. MATAR, maître artisan du cuir"
              className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  'linear-gradient(180deg, transparent 50%, rgba(10,10,15,0.6) 100%)',
              }}
            />
            {/* Caption */}
            <div className="absolute bottom-5 left-5 right-5">
              <p className="font-display text-[#F4E8C1] text-sm tracking-[0.2em] uppercase">
                S.E. MATAR
              </p>
              <p className="text-[#D4AF37] text-xs mt-1 italic font-serif">
                Maître Artisan & Fondateur
              </p>
            </div>
          </div>

          {/* Decorative gold frame accent */}
          <div className="absolute -top-3 -right-3 w-20 h-20 border-t border-r border-[#D4AF37]/60" />
          <div className="absolute -bottom-3 -left-3 w-20 h-20 border-b border-l border-[#D4AF37]/60" />
        </div>

        {/* Right — text content */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="block h-px w-10 bg-[#D4AF37]" />
            <span className="eyebrow">L'Atelier</span>
          </div>

          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-7 leading-tight">
            <span className="text-gold-gradient">L'âme d'une maison,</span>
            <br />
            <span className="text-[#F4E8C1]">le geste d'un maître.</span>
          </h2>

          <div className="space-y-5 text-[#F4E8C1]/75 leading-relaxed font-light">
            <p>
              Né d'une vision partagée entre Dakar et Anvers, l'atelier{' '}
              <span className="text-[#D4AF37]">MATAR STYLE CUIR</span> perpétue
              un art ancestral : celui de transformer le cuir pleine fleur en
              objets de mémoire. Chaque sac, chaque veste, chaque paire de
              chaussures naît d'un dialogue entre la main du maître et la
              matière vivante.
            </p>
            <p>
              Formé aux techniques de sellerie traditionnelle panafricaine puis
              affiné dans les ateliers de la vieille Europe, S.E. MATAR a bâti
              une grammaire stylistique unique : des lignes épurées, des cuirs
              patinés à la cire d'abeille, des coutures sellier apparentes, et
              ce souci du détail qui transforme un accessoire en héritage.
            </p>
            <p>
              Installée au cœur d'Anvers, la maison perpétue cet héritage à
              travers des pièces numérotées, façonnées en série limitée, pour
              celles et ceux qui comprennent que le vrai luxe se mesure à
              l'aune du temps.
            </p>
          </div>

          {/* Stats row */}
          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-[#D4AF37]/15 pt-8">
            {[
              { value: '10+', label: 'Années de métier' },
              { value: '100%', label: 'Fait main' },
              { value: '∞', label: 'Pièces uniques' },
            ].map((s) => (
              <div key={s.label} className="text-center sm:text-left">
                <div className="font-display text-2xl sm:text-3xl text-gold-gradient font-bold">
                  {s.value}
                </div>
                <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-[#F4E8C1]/55 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          {/* Sister boutique link */}
          <a
            href="http://ASMAO-STYLE-CUIR.smartest-capital.org"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-3 text-sm text-[#D4AF37] hover:text-[#F4E8C1] transition-colors group"
          >
            <span className="block h-px w-6 bg-[#D4AF37] group-hover:w-10 transition-all duration-500" />
            <span className="uppercase tracking-[0.2em] text-xs">
              La boutique sœur — Asmao Style Cuir
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
